import { defineTokens } from '@chakra-ui/react'

export const colors = defineTokens.colors({
  // Communo brand ramps — anchored on the design-system hexes
  // (`design/.../colors_and_type.css`). Shades not listed here fall back to
  // Chakra's defaults via the deep merge in `createSystem`.
  yellow: {
    50: { value: '#FFFBEA' },
    100: { value: '#FFF3C4' },
    200: { value: '#FCE588' },
    300: { value: '#FADB5F' },
    400: { value: '#FFDE59' }, // ← THE Communo yellow. Logo & primary CTAs.
    500: { value: '#F0C419' },
    600: { value: '#C99A2E' },
    700: { value: '#8D6708' },
  },
  blue: {
    50: { value: '#EBF2FF' },
    100: { value: '#C7DBFF' },
    300: { value: '#6FA0FF' },
    500: { value: '#1A66FF' }, // secondary — trust, links, info
    600: { value: '#1F4FCC' },
    700: { value: '#163896' },
  },
  pink: {
    50: { value: '#FFE5F2' },
    300: { value: '#FF7AB8' },
    500: { value: '#FF3399' }, // accent — conversion / hero CTA
    600: { value: '#D81E7D' },
    700: { value: '#A21162' },
  },
  gray: {
    50: { value: '#fafafa' },
    100: { value: '#EDF2F7' },
    200: { value: '#E2E8F0' },
    300: { value: '#CBD5E0' },
    400: { value: '#A0AEC0' },
    500: { value: '#718096' },
    600: { value: '#4A5568' },
    700: { value: '#2D3748' },
    800: { value: '#1A202C' },
    900: { value: '#171923' },
    950: { value: '#111111' },
  },
  orange: {
    50: { value: '#fdf4e8' },
    100: { value: '#fce8d1' },
    200: { value: '#fbe2c0' },
    300: { value: '#F6AD55' },
    400: { value: '#E38F3F' },
    500: { value: '#CD6B12' },
    600: { value: '#A74F00' },
    700: { value: '#823800' },
    800: { value: '#5E2100' },
    900: { value: '#390D00' },
    950: { value: '#2a1a05' },
  },
  purple: {
    50: { value: '#fcf8ff' },
    100: { value: '#F3E8FF' },
    200: { value: '#E9D5FF' },
    300: { value: '#D8B4FE' },
    400: { value: '#C084FC' },
    500: { value: '#A855F7' },
    600: { value: '#9333EA' },
    700: { value: '#7E22CE' },
    800: { value: '#6B21A8' },
    900: { value: '#581C87' },
    950: { value: '#3B0764' },
  },
  // Warm cream — the light-mode app canvas (design `C.page`). A neutral cream
  // rather than the yellow ramp, so the page reads calm and cards (white)
  // still stand out. Consumed via the `bg.canvas` semantic token.
  cream: {
    50: { value: '#FEFAEB' },
  },
})
